import { render, staticRenderFns } from "./hqGeneral.vue?vue&type=template&id=0dcbbf40&scoped=true&"
import script from "./hqGeneral.vue?vue&type=script&lang=js&"
export * from "./hqGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcbbf40",
  null
  
)

export default component.exports